<template>
  <div>
    <h2 class="text-lg font-semibold mb-4">Archived Messages</h2>

    <div v-if="messages.length > 0" class="overflow-x-auto">
      <table class="min-w-full bg-white rounded-lg shadow-md">
        <tbody>
        <tr
            v-for="message in messages"
            :key="message.id"
            class="border-t hover:bg-gray-50 transition"
        >
          <td class="px-6 py-4">
            <p class="text-gray-400">{{ message.sender }}</p>
            <div>
              <strong class="ml-1">{{ message.subject }}</strong>
            </div>
          </td>

          <td class="px-6 py-4 text-sm text-gray-500">
            {{ formatDate(message.created_at) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="text-gray-500">No archived messages.</p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import api from "@/services/api";

const messages = ref([])

const fetchArchived = async () => {
  const res = await api.get("/messages/archived", {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  })
  messages.value = res.data
}

function formatDate(dateString) {
  const options = { year: "numeric", month: "short", day: "numeric" }
  return new Date(dateString).toLocaleDateString(undefined, options)
}

onMounted(fetchArchived)
</script>
